import { FilterAltRounded, ReplayRounded, SearchRounded } from "@mui/icons-material";
import { Stack, Button, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

interface IFilterActionsProps {
    expanded: boolean,    // condition for filter status
    onSearch: () => void, // manage event by press search
    onReset: () => void,  // manage event by press reset
    onToggle: () => void, // manage event by press toggle
    hideSearch?: boolean, // condition for hide search botton
    hideReset?: boolean,  // condition for hide reset botton
    hideToogle?: boolean  // condition for hide toggle botton
}

const FilterActions = (props: IFilterActionsProps) => {

    const { t } = useTranslation('booking');

    return (
        <Stack direction="row" alignItems="center" justifyContent="end" columnGap={2}>
            {!props.hideReset &&
                <Button variant="text" startIcon={<ReplayRounded/>} onClick={props.onReset}>
                    {t('label.reset')}
                </Button>
            }
            {!props.hideToogle &&
                <Button variant="text" startIcon={<FilterAltRounded />} onClick={props.onToggle}>
                    {props.expanded ? t('label.close') : t('label.filter')}
                </Button>
            }
            {!props.hideSearch &&
            <Tooltip title={t('label.search')}>
                <Button type="submit" size="icon" color="accent" onClick={props.onSearch}>
                    <SearchRounded/>
                </Button>
            </Tooltip>
            }
        </Stack>
    );
};

export default FilterActions;
